var map = {
	"./16_1688.png": 7750,
	"./login-bg.png": 90130,
	"./login-icon.png": 32976,
	"./statistics-icon-1.png": 90844,
	"./statistics-icon-2.png": 14775,
	"./statistics-icon-3.png": 15278,
	"./statistics-icon-4.png": 13761,
	"./statistics-icon-5.png": 92632,
	"./upload.png": 82456
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 94504;